module.exports = __webpack_public_path__ + "static/media/Miami.54a48f88.png";